import StatusLabel from "Components/Atoms/Label/StatusLabel/StatusLabel";
import { ScopeId } from "Store/Api/PropTypes";
import { baseReducerState, BaseReducerState, baseState, BaseState } from "Store/Shared/Store/PropTypes";

export type Active = 'Active';
export type Blocked = 'Blocked';
export type Loggedin = 'Loggedin';

export type UserAccountStatus = Active | Blocked | Loggedin;
export enum UserStatus {
    Active = 'Active',
    Blocked = 'Blocked',
    Loggedin = 'Loggedin'
}

export type UserId = string;
export type UserProfilePicture = string;
export type UserFirstName = string;
export type UserLastName = string;
export type UserEmail = string;
export type UserCreationDate = number;
export type UserLastLogin = number;

export interface UserState extends BaseState {
    datasets: {
        _isFetching: boolean,
        _forceFetch: boolean,
        ids: string[],
        entities: {},
        selectableList: string[]
    }
}

export const initialUserState: UserState = {
    ...baseState,
    datasets: {
        _isFetching: false,
        _forceFetch: true,
        ids: [],
        entities: {},
        selectableList: []
    }
};